var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeeWhatZem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2291 2H9.77082C5.47911 2 2 5.47913 2 9.77084V44.2292C2 48.5209 5.47911 52 9.77082 52H44.2291C48.5209 52 52 48.5209 52 44.2292V9.77084C52 5.47913 48.5209 2 44.2291 2Z",
    stroke: "#19292C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8643 21.6819C32.6143 19.4528 31.6351 17.2861 29.9268 15.5778C25.9164 11.5673 19.4059 11.5673 15.3955 15.5778C11.3851 19.5882 11.3851 26.0986 15.3955 30.109C19.4059 34.1194 25.9164 34.1194 29.9268 30.109C31.1091 28.9267 31.9372 27.5205 32.4216 26.0309",
    stroke: "#19292C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.499 33.0468C21.749 35.276 22.7282 37.4427 24.4365 39.151C28.4469 43.1614 34.9573 43.1614 38.9678 39.151C42.9782 35.1406 42.9782 28.6302 38.9678 24.6198C34.9573 20.6093 28.4469 20.6093 24.4365 24.6198C23.2542 25.802 22.4261 27.2083 21.9417 28.6979",
    stroke: "#19292C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeWhatZem);
export default __webpack_public_path__ + "static/media/see-what-zem.7a53f1de52bbf4fff9a902b8175b39e6.svg";
export { ForwardRef as ReactComponent };